// TravelTrucks Onboarding Questionnaire structure (5 parts, 15 scored + 3 closing reflections)
// Derived from "TravelTrucks Joy Interview v2"

export const PARTS = [
  {
    id: "part1",
    title: "Wants & Motivations",
    subtitle: "What you're working toward, for yourself and your family.",
    questions: [
      {
        id: "q1",
        category: "Vision & Aspirations",
        prompt:
          "Imagine it is two years from now and things have gone well. What does a really good day look like for you and your family?",
        helper:
          "Think about your daughter or family, the rhythm of your day, what you're doing for work, how you feel.",
      },
      {
        id: "q2",
        category: "Why This Role",
        prompt:
          "What is it about this role at TravelTrucks specifically that made you want to have this conversation?",
        helper: "Skip the generic — what part of it lit something up for you?",
      },
      {
        id: "q3",
        category: "Ideal Working Arrangement",
        prompt:
          "If you could design your ideal working arrangement as a parent and a professional, what would it look like?",
        helper: "Hours, environment, focus blocks, family time — describe it honestly.",
      },
    ],
  },
  {
    id: "part2",
    title: "Needs & Non-Negotiables",
    subtitle: "Things that have to be in place for you to show up fully.",
    questions: [
      {
        id: "q4",
        category: "Deal-Breakers",
        prompt:
          "What would make it impossible for you to show up fully in this role — the things that absolutely cannot be compromised?",
        helper: "We need to know these now, not later.",
      },
      {
        id: "q5",
        category: "Support Structure",
        prompt:
          "Tell us about your support structure at home — who helps you, and how does that shape when and how you can work?",
        helper: "We are asking because we care, not to judge.",
      },
      {
        id: "q6",
        category: "Financial Security",
        prompt:
          "What does financial stability mean to your family right now — what would make a genuine difference to your lives?",
        helper: "Specific is better than polite here.",
      },
    ],
  },
  {
    id: "part3",
    title: "Family & Values Alignment",
    subtitle: "How your people, our people, and our values overlap.",
    questions: [
      {
        id: "q7",
        category: "Family Buy-In",
        prompt:
          "How does your family feel about this opportunity — do they support what you're trying to build?",
        helper: "Their voice matters here.",
      },
      {
        id: "q8",
        category: "Long-Term Relationships",
        prompt:
          "We're not looking for a task executor — we're building an extended family. What does a trustworthy, long-term working relationship look like to you?",
      },
      {
        id: "q9",
        category: "Human-First Workplace",
        prompt:
          "Our value is that the people we work with are human beings first. What would it mean to you to work somewhere that genuinely held that value — and what would you need to see in the first 90 days to believe it is real?",
      },
    ],
  },
  {
    id: "part4",
    title: "Growth & Comfort Zone",
    subtitle: "How you handle learning, the unknown, and asking for help.",
    questions: [
      {
        id: "q10",
        category: "Reaction to the Growth Pathway",
        prompt:
          "This role will ask you to learn things you have not done before — Go High Level, SEO, AI tools, eventually leading a small team. When you hear that list, what's your honest reaction?",
      },
      {
        id: "q11",
        category: "Learning Under Pressure",
        prompt:
          "Tell us about a time you had to learn something completely new and unfamiliar under pressure. How did you approach it, and what happened in the end?",
      },
      {
        id: "q12",
        category: "Asking When You Don't Know",
        prompt:
          "Sometimes there's a hesitation to ask questions when we're not sure. How do you personally handle that moment when you do not know something?",
        helper: "There is no wrong answer here — we just want the real one.",
      },
    ],
  },
  {
    id: "part5",
    title: "Trust & Team Fit",
    subtitle: "Being the first remote team member, raising concerns, belonging.",
    questions: [
      {
        id: "q13",
        category: "Remote Connection",
        prompt:
          "You'd be working remotely for an Australian company. What would help you feel genuinely connected to the team and the brand — not just to the work?",
      },
      {
        id: "q14",
        category: "Raising Concerns",
        prompt:
          "If something wasn't working — a task you didn't understand, a direction that felt wrong, a deadline that wasn't realistic — how would you handle bringing that to your manager?",
      },
      {
        id: "q15",
        category: "Being First",
        prompt:
          "We intend to build a team of up to five people from the Philippines. You would be the first. What does being part of something like that mean to you?",
      },
    ],
  },
];

export const CLOSING_REFLECTIONS = [
  {
    id: "c1",
    prompt:
      "It sounds like you may have been building something real on your own without a structure behind you. What do you think you could do with one?",
  },
  {
    id: "c2",
    prompt: "What would stop you from fully saying yes to this?",
  },
  {
    id: "c3",
    prompt:
      "If this role worked exactly the way you hoped it would — what would your family say about you in five years' time?",
  },
];

export const SCORE_LABELS = {
  1: "Concerning",
  2: "Needs Development",
  3: "Acceptable",
  4: "Strong",
  5: "Outstanding",
};
